<div class="topbar">
  <div class="container-fluid">
    <ng-container *ngIf="!isLoggedIn; else LoggedInBar">
      <nav class="nav justify-content-center pb-1">
        <a class="nav-link text-white" [ngClass]="{'visually-hidden': isInHome()}" href="/home">Home</a>
        <a class="nav-link text-white" [ngClass]="{'visually-hidden': currentRoute === '/quem-somos'}" href="/quem-somos">Quem Somos</a>
        <a class="nav-link text-white" [ngClass]="{'visually-hidden': currentRoute === '/koortimativa'}" href="/koortimativa">A Koortimativa</a>
        <a class="nav-link text-white" [ngClass]="{'visually-hidden': currentRoute === '/ferramenta'}" href="/ferramenta">A Ferramenta</a>
        <a class="nav-link text-white" [ngClass]="{'visually-hidden': currentRoute === '/auth/login'}" href="/auth/login">Login</a>
      </nav>
    </ng-container>
    <ng-template #LoggedInBar>
      <nav class="nav pb-1">
        <div class="col-md-1"></div>
        <div class="col-md-8 col-12 user-block">
          <div class="pe-0 ps-0">
            <img class="w-75" src="/assets/img/koort-logo-orange-vertical.svg"
                 alt="Logo Koort">
          </div>
          <div class="text-white">
            Olá, {{user["name"]}}!
          </div>
        </div>
        <div class="col-md-3 col-12 flex align-items-center">
          <ng-container *ngIf="isUserMenu; else ReturnToMenu">
            <a type="button" class="text-decoration-none me-4" (click)="openDashboard()">Dashboard</a>
            <a type="button" class="text-decoration-none me-4" (click)="openModal(Intitucional)">Institucional</a>
          </ng-container>
          <ng-template #ReturnToMenu>
            <a href="/user-menu" class="text-decoration-none me-4">Voltar ao menu</a>
          </ng-template>
          <button class="btn btn-primary" (click)="logoutUser()">Sair</button>
        </div>
        <div class="col-md-1"></div>
      </nav>
    </ng-template>
  </div>
</div>

<ng-template #Intitucional>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Institucional</h4>
  </div>
  <div class="modal-body justify-text">
    <p>A
    <span style="font-weight: 700">KOORTimativa</span>
    é uma empresa especializada na estimação de preços de imóveis. A metodologia desenvolvida segue as normas da ABNT e emprega critérios estatísticos rigorosos, além de utilizar ferramentas de inteligência artificial para estimar os preços de mercado no setor imobiliário. Desta forma, os preços de mercado estimados são bastante robustos e não estão influenciados por nenhum modelo de negócio prévio de nossa plataforma.
    </p>
    <p>
      O
      <span style="font-weight: 700">Relatório Auxiliar de Avaliação do Imóvel (RAAI)</span>
      consolida em um único documento um conjunto de informações que são fundamentais para a análise do preço de um imóvel específico. Além da estimativa de preço e seus intervalos máximo e mínimo, o RAAI inclui também a localização do imóvel no mapa, os pontos relevantes do entorno, as principais variáveis que afetam o preço de um imóvel, além da seleção de imóveis similares para efeito de comparação. Isso permite um aumento da eficiência e eficácia da avaliação, reduzindo o tempo dispendido e elevando a acurácia de todo o processo.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="institutionalModalRef.hide()">Fechar</button>
  </div>
</ng-template>
